<template>
  <v-container>
    <v-row>
      <v-col cols="12" xl="6" lg="6" md="8" sm="10" >
        <v-card class="elevation-0" >
          <v-card-title primary-title>
            Información sobre mi cuenta
          </v-card-title>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              :lazy-validation="lazy"
            >
              <v-text-field
              	:readonly="readonly"
                v-model="usuario.nomper"
                :counter="50"
                :rules="nameRules"
                label="Nombre"
                required
              ></v-text-field>

              <v-text-field
              	:readonly="readonly"
                v-model="usuario.nomuser"
                :counter="15"
                label="Nombre de usuario"
              ></v-text-field>

              <v-text-field
              	readonly
                v-model="usuario.email"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>

              <v-btn
              	v-if="readonly == false"
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="update"
              >
                Actualizar
              </v-btn>

              <v-btn
              	v-else
                color="success"
                class="mr-4"
                @click="readonly = false"
              >
                Editar información
              </v-btn>

              <v-btn
                color="secondary"
                class="mr-4"
                @click="cambiarContra"
              >
                Actualizar Contraseñas
              </v-btn>

            </v-form>
          </v-card-text>

          <v-card-text v-if="contra == true">
            <v-text-field
              v-model="password1"
              prepend-icon="lock"
              :append-icon="show1 ? 'visibility' : 'visibility_off'"
              :type="show1 ? 'text' : 'password'"
              label="contraseña actual"
              hint="Máximo 30 caracteres"
              :counter="30"
              required
              @click:append="show1 = !show1"
            ></v-text-field>

            <v-text-field
              v-model="password2"
              prepend-icon="lock"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              :type="show ? 'text' : 'password'"
              label="Nueva contraseña"
              hint="Máximo 30 caracteres"
              :counter="30"
              required
              @click:append="show = !show"
            ></v-text-field>
          </v-card-text>
          <v-card-actions v-if="contra == true">
            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              @click="compararContra"
            >
              Actualizar
            </v-btn>

            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              @click="contra = false"
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="4000"
      top
      :color="color"
    >
      {{text}}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>

</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  var md5     = require('md5')

  export default{
    data(){
      return{
      	readonly: true,

        usuario: {},
        lazy: false,

        valid: true,
        name: '',
        nameRules: [
          v => !!v || '*Requerido',
          v => (v && v.length <= 50) || 'Máximo 50 caracteres',
        ],
        emailRules: [
          v => !!v || '*Requerido',
          v => /.+@.+\..+/.test(v) || 'email no valido',
        ],
        lazy: false,

        contra: false,


        perfilUser: '',
        editar: true,
        disabled: true,
        snackbar: false,
        text:    '',
        color:   '',

        // VARIABLES PARA CONTRASEÑA
        password1:'',
        password2:'',

        // VER PASSWORD
        show: true,
        show1: true,

        rules: {
          required: value => !!value || 'Requerido.',
          min: v => v.length >= 5 || 'Minimo 5 caracteres',
          emailMatch: () => ('El correo y/o la contraseña no son correctos')
        }
      }
    },

    created () {
      console.log('getdatosUsuario',this.getdatosUsuario) 
      this.cargarInfo(this.getdatosUsuario.idusuariosweb)
    },

    methods:{
      cargarInfo(id){
        this.$http.get('users/' + id).then(response => { 
          this.usuario = response.body
        }).catch(error=>{
            console.log(error)
        })
      },

      cambiarContra(){
        this.contra = true
      },

      compararContra(){
        if(md5(this.password1) == this.usuario.password){
          this.usuario.password = md5(this.password2)
          this.update()
        }
      },

      update(){
        var id =  this.getdatosUsuario.idusuariosweb
        this.$http.put('updateuser/'+ id, this.usuario).then(response=>{
          this.snackbar = true 
          this.text ="Los datos han sido actualizados "
          this.color ="green"
          this.password1 = ''
          this.password2 = ''
          this.contra = false
          this.readonly = true
          this.cargarInfo(id)
        }).catch(error=>{console.log(error)})
      }

    },
    computed:{
      ...mapGetters('login',['getdatosUsuario', 'getLogeado']),
      tamanioDisplay () {
        console.log(this.$vuetify.breakpoint)
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return this.$vuetify.breakpoint.height - 300
          break;
          case 'sm': 
            return this.$vuetify.breakpoint.height - 300
          break;
          case 'md':
            return this.$vuetify.breakpoint.height - 300
          break;
          case 'lg':
            return this.$vuetify.breakpoint.height - 300 
          break;
          case 'xl':
            return this.$vuetify.breakpoint.height - 300
          break;
        }
      },
    },

  };
</script>